'use strict';

import _ from 'lodash';

import React from 'react';
import PropTypes from 'prop-types';
import PasswordVerifier from 'ck-core/source/verifiers/user/PasswordVerifier';
import MinecraftNameVerifier from 'ck-core/source/verifiers/user/MinecraftNameVerifier';
import DateOfBirthVerifier from 'ck-core/source/verifiers/user/DateOfBirthVerifier';
import Form from 'ck-core-client/source/ui/Form.jsx';
import TextInput from 'ck-core-client/source/ui/form/TextInput.jsx';
import EmailInput from 'ck-core-client/source/ui/form/EmailInput.jsx';
import GenderInput from 'ck-core-client/source/ui/form/GenderInput.jsx';
import DateOfBirthInput from 'ck-core-client/source/ui/form/DateOfBirthInput.jsx';
import lang from './AccountDetailsLang.jsx';

export default class AccountDetails extends React.Component {
	render() {
		return (
			<div className="AccountDetails">
				<div className="header">Details</div>
				<Form handleSubmit={this.props.handleSubmit} buttonText={lang.FORM.button}>
					<EmailInput
						label={this.props.isBillingOnlyUser ? lang.FORM.paymentEmail : lang.FORM.email}
						checkForDuplicates={!this.props.isBillingOnlyUser}
						name={this.props.isBillingOnlyUser ? 'paymentEmail' : 'email'}
						optional={true}
						value={
							this.props.isBillingOnlyUser
								? this.props.defaultValues.paymentEmail
								: this.props.defaultValues.email
						}
					/>
					<TextInput
						label={lang.FORM.password}
						name="password"
						type="password"
						placeholder={this.props.hasPassword ? '********' : undefined}
						value={this.props.defaultValues.password}
						optional={true}
						validate={
							new PasswordVerifier({
								required: false
							})
						}
					/>
					{!this.props.isBillingOnlyUser && (
						<GenderInput name="gender" value={this.props.defaultValues.gender} optional={true} />
					)}
					{!this.props.isBillingOnlyUser && (
						<DateOfBirthInput
							label={lang.FORM.dateOfBirth}
							name="dateOfBirth"
							value={this.props.defaultValues.dateOfBirth}
							optional={true}
							validate={
								new DateOfBirthVerifier({
									required: false
								})
							}
						/>
					)}
					{!this.props.isBillingOnlyUser && (
						<TextInput
							label={lang.FORM.minecraftName}
							name="minecraftName"
							value={this.props.defaultValues.minecraftName}
							optional={true}
							validate={
								new MinecraftNameVerifier({
									required: false
								})
							}
						/>
					)}
					{!this.props.isBillingOnlyUser && (
						<TextInput
							label={lang.FORM.minecraftPeName}
							name="minecraftPeName"
							value={this.props.defaultValues.minecraftPeName}
							optional={true}
						/>
					)}
				</Form>
			</div>
		);
	}
}

AccountDetails.fields = [
	'minecraftName',
	'minecraftPeName',
	'email',
	'paymentEmail',
	'gender',
	'dateOfBirth'
];

AccountDetails.propTypes = {
	hasPassword: PropTypes.bool,
	isBillingOnlyUser: PropTypes.bool,
	defaultValues: PropTypes.shape(
		_.zipObject(AccountDetails.fields, _.map(AccountDetails.fields, () => PropTypes.any))
	).isRequired,
	handleSubmit: PropTypes.func.isRequired
};
